export default __webpack_public_path__ + "static/back-dca60375365028b71f7f0079dd0285d7.png";